export interface IAcoustic {
  id?: string;
  locationname?: string;
  deviceid?: string;
  startcapture?: Date;
  endcapture?: Date;
  filecount?: number;
  soundtype?: AcousticSoundType;
  sizedata?: number;
  devicetype?: AcousticDeviceType;
  height?: number;
  softwareversion?: string;
  comments?: string;
  createdby: string;
  groupid?: string;
  groupname?: string;
  userlogin?: string;
}

export enum ACOUSTIC_SOUND_TYPES {
  "audible" = "Audible",
  "ultrasonic" = "Ultrasonic"
};
export type AcousticSoundType = keyof typeof ACOUSTIC_SOUND_TYPES;

export enum ACOUSTIC_DEVICE_TYPES {
  "audiomoth" = "Audiomoth",
  "anabatswift" = "Anabatswift"
};
export type AcousticDeviceType = keyof typeof ACOUSTIC_DEVICE_TYPES;
